function Footer (){
    return(
        <footer className="FooterPrincipal">
            &copy; Todos los derechos reservados
        </footer>
    )
}

export default Footer;